import Button from "../../../Buttons/Button";
import React, { FormEvent, useCallback, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Column } from "../../../../style";
import { secondary } from "../../../../theme";
import { useApi } from "../../../../hooks/api";
import { useGlobal } from "../../../../hooks/global";
import { activityOptions } from "../options/activityOptions";
import { sendTypeOptions } from "../options/sendTypeOptions";
import { mapperTimeModes } from "../options/timeModeOptions";
import { ModalLoading } from "../../../Loadings/ModalLoading";
import { ContainerButtons, ContainerForm, Form } from "./style";
import { GenericForm, IGenericFormRefProps } from "../../../GenericForm";
import { IGroupProps, INotificationRulesProps } from "../../../../interfaces";
import { validateEmail, validatePhoneWithDDI } from "../../../../utils/validatesFields";
import { recipientTypeOptions } from "../options/recipientTypeOptions";
import { checkInStatusOptions, reservationStatusOptions } from "../../../../utils/options";
import parsePhoneNumberFromString from "libphonenumber-js";

interface IFormModalNotificationRuleProps {
  onCancel: Function;
  onSave: Function;
  defaultData?: INotificationRulesProps | null;
  accommodationOptions: { label: string; value: string }[];
  groupOptions: { label: string; value: string }[];
  wppModels: { label: string; value: string }[];
  emailModels: { label: string; value: string }[];
  reservationsOriginOptions: { label: string; value: string }[];
}


export const timeSendNotificationOptions: { value: string; label: string }[] = [
  { value: '0', label: '00:00' },
  { value: '1', label: '01:00' },
  { value: '2', label: '02:00' },
  { value: '3', label: '03:00' },
  { value: '4', label: '04:00' },
  { value: '5', label: '05:00' },
  { value: '6', label: '06:00' },
  { value: '7', label: '07:00' },
  { value: '8', label: '08:00' },
  { value: '9', label: '09:00' },
  { value: '10', label: '10:00' },
  { value: '11', label: '11:00' },
  { value: '12', label: '12:00' },
  { value: '13', label: '13:00' },
  { value: '14', label: '14:00' },
  { value: '15', label: '15:00' },
  { value: '16', label: '16:00' },
  { value: '17', label: '17:00' },
  { value: '18', label: '18:00' },
  { value: '19', label: '19:00' },
  { value: '20', label: '20:00' },
  { value: '21', label: '21:00' },
  { value: '22', label: '22:00' },
  { value: '23', label: '23:00' },
];

export const FormModalNotificationRule: React.FC<IFormModalNotificationRuleProps> = (props) => {
  const { onSave, defaultData, accommodationOptions, groupOptions, wppModels, emailModels, reservationsOriginOptions } = props;

  const { theme, notify } = useGlobal();
  const { api } = useApi();

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setError,
    setValue,
    trigger,
  } = useForm({
    defaultValues: defaultData?.id ? defaultData : ({} as any),
    mode: "all",
  });

  const _form = watch();

  const form_ref = useRef<IGenericFormRefProps>(null);
  const submitButtonRef = useRef<HTMLButtonElement>(null);
  const [loadingCreate, setLoadingCreate] = useState(false);

  const onSubmit = useCallback(async () => {
    setLoadingCreate(true);

    try {
      const form = form_ref.current?.getForm();

      const send_type = form?.["send_type"];

      let ddi = form["ddi"]
      if(!ddi) ddi = "+55";

      const recipient_other_value =
        send_type === "email"
          ? form?.["recipient_email"]
          : ddi + form["recipient_phone"] || '';


      delete form?.["recipient_email"];
      delete form?.["recipient_phone"];
      delete form?.["ddi"];

      form['recipient_other_value'] = recipient_other_value;

      form['reservations_origin'] = form?.["reservations_origin"]?.map((item: { id: string }) => item?.id);
      form['reservations_status'] = form?.["reservations_status"]?.map((item: { id: string }) => item?.id);
      form['checkin_status'] = form?.["checkin_status"]?.map((item: { id: string }) => item?.id);

        if (defaultData?.id) {
          await api.put(`/notification-rules/${defaultData?.id}`, form);
        } else {
          await api.post("/notification-rules", form);
        }
  
      notify(
        `Regra de notificação ${defaultData?.id ? "atualizada" : "criada"} com sucesso!`,
        "success"
      );

        onSave();
    } catch (err: any) {
      const error = err.response ? err.response?.data : "SERVER ERROR";
      if (error.field) setError(error.field, { type: "manual", message: error.detail });
      else notify("ERRO INTERNO DO SISTEMA", "error");
    }

    setLoadingCreate(false);
  }, [form_ref, _form, api]);

  const handleStopPropagation = useCallback((e: FormEvent<HTMLFormElement>) => {
    e?.stopPropagation();
    handleSubmit(onSubmit)(e);
  }, [handleSubmit, onSubmit, form_ref, _form, api]);

  const groups: IGroupProps[] = [
    {
      name: "",
      label: "",
      fields: [
        [
          {
            name: "name",
            label: "Nome",
            type: "input",
            isClearable: true,
            required: true,
          },
        ],
        [
          {
            name: "send_type",
            label: "Tipo de envio",
            type: "select-fixed",
            required: true,
            isClearable: true,
            options: sendTypeOptions,
          },
          {
            name: "activity",
            label: "Atividade",
            type: "select-fixed",
            required: true,
            isClearable: true,
            options: activityOptions,
          },
        ],
        [
          {
            name: "reservations_status",
            label: "Status da reserva",
            type: "select-fixed-multi",
            required: false,
            isClearable: true,
            options: reservationStatusOptions?.filter((item: any) => item?.value !== "contract"),
          },
          {
            name: "checkin_status",
            label: "Status do check-in",
            type: "select-fixed-multi",
            required: false,
            isClearable: true,
            options: checkInStatusOptions?.filter((item: any) => item?.value !== "not_realized"),
          },
        ],
        [
          {
            name: "reservations_origin",
            label: "Origem da reserva",
            type: "select-fixed-multi",
            required: false,
            isClearable: true,
            options: reservationsOriginOptions,
          },
          {
            name: "time_mode",
            label: "Tempo para envio",
            type: "select-fixed",
            required: true,
            isClearable: true,
            getOptions: (form) => {
              if (!form?.activity?.value) return [];
              return mapperTimeModes?.[form?.activity?.value] ?? [];
            },
          },
          {
            name: "time_send_notification",
            label: "Hora de envio de notificações",
            type: "select-fixed",
            required: false,
            isClearable: true,
            options: timeSendNotificationOptions,
          },
        ],
        [
          {
            name: "recipient_type",
            label: "Destinatário",
            type: "select-fixed",
            isClearable: true,
            options: recipientTypeOptions,
            required: true,
          },
          {
            name: "ddi",
            label: "DDI",
            type: "select-country",
            required: false,
            noUpperCase: true,
            getIsDisabled: (data) => !data["recipient_type"]?.value,
            canSee: (data) =>
            (data["send_type"]?.value === "wpp"
              && data["recipient_type"]?.value === 'other'
            ),
          },
          {
            name: "recipient_phone",
            label: "Telefone",
            type: "phone-adm",
            required: true,
            validate: validatePhoneWithDDI,
            mask: "phone",
            noUpperCase: true,
            getIsDisabled: (data) => !data["recipient_type"]?.value,
            canSee: (data) =>
            (data["send_type"]?.value === "wpp"
              && data["recipient_type"]?.value === 'other'
            ),
          },
          {
            name: "recipient_email",
            label: "Email",
            type: "input",
            validate: validateEmail,
            required: true,
            getIsDisabled: (data) => !data["recipient_type"]?.value,
            canSee: (data) =>
            (data["send_type"]?.value === "email"
              && data["recipient_type"]?.value === 'other'
            ),
          },
          {
            name: "model_id",
            label: "Modelo",
            type: "select-fixed",
            required: true,
            isClearable: true,
            options: wppModels,
            getOptions: (form) => form?.send_type?.value === "wpp" ? wppModels : emailModels,
          }
        ],
        [
          {
            name: "accommodation_id",
            label: "Acomodação",
            type: "select-fixed",
            isClearable: true,
            options: accommodationOptions,
            getIsDisabled: (form) => !!form?.group_id?.value,
          },
          {
            name: "group_id",
            label: "Grupo",
            type: "select-fixed",
            isClearable: true,
            options: groupOptions,
            getIsDisabled: (form) => !!form?.accommodation_id?.value,
          },
        ]
      ],
    },
  ];

  useEffect(() => {
    if (!defaultData?.id) setValue('time_mode', null);
  }, [_form.send_type])

  return (
    <>
      <Column style={{ flex: 1, overflow: "auto", padding: 20 }}>
        <ContainerForm open>
          <Form onSubmit={handleStopPropagation}>
            <GenericForm
              ref={form_ref}
              groups={groups}
              _form={_form}
              control={control}
              trigger={trigger}
              errors={errors}
              setValue={setValue}
              register={register}
            />
            <button
              className="display-none"
              type="submit"
              ref={submitButtonRef}
            />
          </Form>
        </ContainerForm>
      </Column>

      <ContainerButtons theme={theme}>
        <Button
          onClick={() => submitButtonRef.current?.click()}
          background={secondary[theme]}
          color={"#FFF"}
          style={{ padding: 8, maxWidth: 150, fontSize: 14 }}
          children={"Salvar"}
        />
      </ContainerButtons>

      <ModalLoading loading={loadingCreate} theme={theme} />
    </>
  );
};
